export default {
  menu: {
    sports: "Deportes",
    referAndEarn: "Recomienda y Gana",
    referDesc: "hasta 60% de comisión",
    copyLink: "Copiar Enlace",
    hot: "Populares",
    favorites: "Favoritos",
    recent: "Recientes",
    vipClub: "Club VIP",
    bonus: "Bono",
    bonusGames: "Juegos de Bono",
    affiliate: "Afiliado",
    promotion: "Promoción",
    rewards: "Recompensas",
    help: "Ayuda",
    feedback: "Comentarios",
    downloadApp: "Descargar App",
    claimBonus: "Reclamar Bono",
    redeemCode: 'Canjear Código',
    redeemDesc: 'Reclama Tu Recompensa Gratis',
    liveSupport: "Soporte en Vivo",
    language: "Idioma",
	search: "search"
  }
}
